import { FamilyService } from '@app/services/family/family.service';
import { Component } from '@angular/core';
import { PdvService } from '@app/services/pdv/pdv.service';

@Component({
    selector: 'products',
    templateUrl: 'products.component.html',
    styleUrls: ['products.component.scss'],
    providers: [FamilyService]
})
export class ProductsComponent {

    families: any[] = [];
    menucategories: any[] = [];
    loading = false
    city = "";
    loadAvatar=false;
    constructor(private familyService: FamilyService, private pdvService: PdvService) {
        this.pdvService.pdv.subscribe(
            (pdv) => {
                if (pdv) {
                    this.city = pdv.city;
                }
            }
        )
    }
    ngOnInit() {
        this.getFamiliesOfCarte();
        this.getMenuCategoriesOfCarte();
    }
    getFamiliesOfCarte() {
        this.loading = true;
        this.familyService.getFamiliesOfCarte().subscribe(
            (families: any[]) => {
                this.families = families.sort(
                    (a, b) => {
                        if (a.order === null) {
                            return 1;
                        }
                        else if (b.order === null) {
                            return -1;
                        }
                        if (Number(a.order) > Number(b.order)) {
                            return 1;
                        }
                        if (Number(a.order) < Number(b.order)) {
                            return -1;
                        }
                        return 0;
                    }
                );
                this.loading = false;
            }
        )
    }
    getMenuCategoriesOfCarte() {
        this.loading = true;
        this.familyService.getMenuCategoriesOfCarte().subscribe(
            (menucategories: any[]) => {
                this.loading = false;
                this.menucategories = menucategories.sort(
                    (a,b)=>{
                        if (a.order === null) {
                            return 1;
                        }
                        else if (b.order === null) {
                            return -1;
                        }
                        if(a.order>b.order){
                            return 1;
                        }
                        if(a.order<b.order){
                            return -1;
                        }
                        return 0;
                    }
                )
            }
        )
    }
}
